import { useEffect } from "react";
import { useSettings } from "../contexts/SettingsContext";

/**
 * Loads Meta (Facebook) Pixel and Microsoft Clarity scripts dynamically once
 * IDs are available from /api/settings. Admins configure them via the
 * SiteSettings panel — no code change required to swap pixels.
 *
 * Idempotent: each script is injected at most once per page load.
 */
export default function TrackingPixels() {
  const { settings, loaded } = useSettings();

  useEffect(() => {
    if (!loaded) return;

    // ---- Meta Pixel ----
    const pixelId = (settings.meta_pixel_id || "").trim();
    if (pixelId && !window.__metaPixelLoaded) {
      window.__metaPixelLoaded = true;
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq("init", pixelId);
      window.fbq("track", "PageView");
    }

    // ---- Microsoft Clarity ----
    const clarityId = (settings.clarity_id || "").trim();
    if (clarityId && !window.__clarityLoaded) {
      window.__clarityLoaded = true;
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", clarityId);
    }
  }, [loaded, settings.meta_pixel_id, settings.clarity_id]);

  return null;
}
